import React from "react";

const SendIcon = () => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M21.9988 11.9986C21.9988 12.0933 21.9719 12.1861 21.9212 12.2661C21.8705 12.3461 21.7982 12.4101 21.7126 12.4506L3.71256 20.9506C3.62265 20.9942 3.52172 21.0097 3.42287 20.9952C3.32402 20.9806 3.23183 20.9367 3.15828 20.8691C3.08473 20.8014 3.03322 20.7133 3.01044 20.616C2.98766 20.5187 2.99467 20.4168 3.03056 20.3236L5.87256 12.6966C6.04023 12.2463 6.04023 11.7508 5.87256 11.3006L3.02956 3.67357C2.99349 3.58021 2.98639 3.47815 3.00918 3.3807C3.03196 3.28325 3.08359 3.19492 3.15732 3.12724C3.23104 3.05955 3.32345 3.01566 3.4225 3.00127C3.52154 2.98688 3.62262 3.00267 3.71256 3.04657L21.7126 11.5466C21.7982 11.5871 21.8705 11.651 21.9212 11.7311C21.9719 11.8111 21.9988 11.9039 21.9988 11.9986ZM21.9988 11.9986H5.99856"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default SendIcon;
